// extracted by mini-css-extract-plugin
module.exports = {"primaryColour":"#09CCC4","midGreyColour":"#868686","header":"Header-module--header--pV09J","titles":"Header-module--titles--3PxQ9","wheel":"Header-module--wheel--26_E-"};